import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../shared/Fetch";
import { IBranchMastDropdown, ICompanyMastDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { ILogin } from "../../models/Login";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
    year: yup.date().nullable()
})
export interface IFilterTarget {
    sm?: number | null,
    company?: number | null,
    branch?: number | null,
    recruiter_ID: number | null,
    team?: number | null,
    reporting_Period?: number | null,
    year?: Date | null,
    month?: Date | null,
    quaterly?: number | null,
    half_Yearly?: number | null
}

export const EmptyFilter: IFilterTarget = {
    sm: null,
    company: null,
    branch: null,
    recruiter_ID: null,
    team: null,
    reporting_Period: null,
    year: null,
    month: null,
    quaterly: null,
    half_Yearly: null
}

interface Iprops {

    filters: IFilterTarget,
    setFilters: (filters: IFilterTarget) => void,
    toast: any
}
export const Filter = (props: Iprops) => {

    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [year, setYear] = useState<any>(null);
    const [month, setMonth] = useState<any>(null);
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [option, setOption] = useState<number | null>(null);


    useEffect(() => {
        loadBranch();
    }, []);

    const { control, handleSubmit, reset, watch, formState: { errors } } = useForm<IFilterTarget>({
        defaultValues: EmptyFilter,
        resolver: yupResolver(schema),
        shouldFocusError: false
    });



    const searchToDB = async (body: IFilterTarget) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setFilters(body);
    }


    function onSubmit(data: IFilterTarget) {
        data.month = month
        data.year = year
        if (data.reporting_Period === null || data.reporting_Period === 0) {
            data.month = null;
            data.year = null;
            searchToDB(data);
        } else {
            if (data.reporting_Period == 2 && year !== null) {
                if (control._formValues.quaterly == 0 || control._formValues.quaterly == null) props.toast.current.show({ severity: 'error', detail: "Please Select Quaterly", life: 3000 });
                else searchToDB(data);
            } else if (data.reporting_Period !== 1 && year == null) {
                if (data.reporting_Period == 2 && (control._formValues.quaterly == 0 || control._formValues.quaterly == null)) props.toast.current.show({ severity: 'error', detail: "Please Select Year and Quaterly", life: 3000 });
                else props.toast.current.show({ severity: 'error', detail: "Please Select Year", life: 3000 });
            } else if (data.reporting_Period == 1 && month == null) {
                props.toast.current.show({ severity: 'error', detail: "Please Select Month", life: 3000 });
            } else {
                searchToDB(data);
            }
        }
    }


    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }
    const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }
    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }
    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }
    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "reporting_Period") {
                if (value.reporting_Period === 4) { setOption(4); setMonth(null); control._formValues.quaterly = null; control._formValues.half_Yearly = null }
                else if (value.reporting_Period === 3) { setOption(3); setMonth(null); control._formValues.quaterly = null }
                else if (value.reporting_Period === 2) { setOption(2); setMonth(null); control._formValues.half_Yearly = null }
                else if (value.reporting_Period === 1) { setOption(1); control._formValues.quaterly = null; control._formValues.half_Yearly = null }
                else setOption(null);


            }
            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam(0, value.company);
                    loadSm(0, value.company, 0);
                    loadBranch(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranch();
                        loadTeam(control._formValues.branch, value.company);
                        loadRecruiters(control._formValues.branch, value.company, control._formValues.team);
                        loadSm(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadTeam(value.branch, 0);
                    loadSm(value.branch, 0, 0);
                    loadRecruiters(value.branch, 0, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadTeam(value.branch, control._formValues.company);
                        loadRecruiters(value.branch, control._formValues.company, control._formValues.team);
                        loadSm(value.branch, control._formValues.company, control._formValues.team);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadSm(0, 0, value.team);
                    loadRecruiters(0, 0, value.team);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadRecruiters(control._formValues.branch, control._formValues.company, value.team);
                        loadSm(control._formValues.branch, control._formValues.company, value.team);
                    }
                }
            }

        });

        return () => subscription.unsubscribe();
    }, [watch]);


    useEffect(() => {
        loadTeam(0, 0);
        loadRecruiters(0, 0, 0);
        loadSm(0, 0, 0);
        loadBranch();
        loadCompany();
    }, []);
    const onClear = () => {
        reset(EmptyFilter)
        loadSm(0, 0, 0);
        loadTeam(0, 0, "");
        loadBranch();
        loadCompany();
        loadRecruiters(0, 0, 0);
        setOption(null);
        setYear(null);
        setMonth(null);
    }

    const DropDown: { name: string, value: number }[] = [
        { name: "-- SELECT --", value: 0 },
        { name: "Monthly", value: 1 },
        { name: "Quaterly", value: 2 },
        // { name: "Half Yearly", value: 3 },
        { name: "Annualy", value: 4 },
    ];
    const DropDownQuater: { name: string, value: number }[] = [
        { name: "-- SELECT --", value: 0 },
        { name: "JANUARY   -  MARCH", value: 1 },
        { name: "APRIL -  JUNE", value: 2 },
        { name: "JULY  -   SEPTEMBER", value: 3 },
        { name: "OCTOBER   -  DECEMBER", value: 4 },
    ];
    // const DropDownHalf: { name: string, value: number }[] = [
    //     { name: "APRIL   -  SEPTEMBER", value: 1 },
    //     { name: "OCTOBER  -   MARCH", value: 2 },

    // ];
    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label="Company Name " control={control} name="company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
            <JVDropdown column={6} label="Branch " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " />
            <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            {(_role.includes(2) || _role.includes(5) || _role.includes(1)) && <JVDropdown column={6} label="Sales Manager" control={control} name="sm" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales" />}
            {(_role.includes(3) || _role.includes(4) || _role.includes(1) || _role.includes(21)) && <JVDropdown column={6} label="Recruiter" control={control} name="recruiter_ID" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />}
            <JVDropdown column={6} label="Reporting Period" control={control} name="reporting_Period" options={DropDown} optionLabel="name" optionValue="value" placeholder="Select Reporting Period" />
            {((option != null && option != 1 && option != 0) && <div className="field col-12 md:col-2 "  >
                <label>Year</label>
                <Calendar value={year} onChange={(e) => setYear(e.value)} view="year" name="year" dateFormat="yy" showIcon />

            </div >)}
            {(option === 1 && <div className="field col-12 md:col-2 " >
                <label>Month</label>
                <Calendar value={month} onChange={(e) => setMonth(e.value)} name="month" view="month" dateFormat="mm/yy" showIcon />

            </div >)}
            {option === 2 && <JVDropdown column={6} label="Quaterly" control={control} name="quaterly" options={DropDownQuater} optionLabel="name" optionValue="value" placeholder="Select Reporting Period" />}
            {/* {option === 3 && <JVDropdown column={6} label="Half Yearly" control={control} name="half_Yearly" options={DropDownHalf} optionLabel="name" optionValue="value" placeholder="Select Reporting Period" />} */}
            <div style={{ margin: '10px 0', width: '100%' }}></div>
            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
            </div>
        </form>

    )
}

